import { useEffect, useState } from "react";

function resolveInitialValue(initialValue) {
  return typeof initialValue === "function" ? initialValue() : initialValue;
}

export function useLocalStorageState(
  storageKey,
  initialValue,
  normalizeValue,
) {
  const [state, setState] = useState(() => {
    if (typeof window === "undefined") {
      return resolveInitialValue(initialValue);
    }

    const savedValue = window.localStorage.getItem(storageKey);
    if (!savedValue) {
      return resolveInitialValue(initialValue);
    }

    try {
      const parsedValue = JSON.parse(savedValue);
      return normalizeValue ? normalizeValue(parsedValue) : parsedValue;
    } catch {
      return resolveInitialValue(initialValue);
    }
  });

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    window.localStorage.setItem(storageKey, JSON.stringify(state));
  }, [state, storageKey]);

  return [state, setState];
}
